@if (dataSource.length > 0) {
  <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
    @for (column of columns; track column.keyColumn) {
      <ng-container matColumnDef="{{ column.keyColumn }}">
        <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
        <td mat-cell *matCellDef="let element">
          @if (column.keyColumn == 'action') {
            <div class="flex justify-center items-center gap-3">
              <mat-icon
                *ngIf="column.key.edit"
                class="btn-icon-outline"
                fontIcon="edit"
                matTooltip="Editar"
                (click)="selectItemEvent(element)"
              />

              <mat-icon
                *ngIf="column.key.manager"
                class="btn-icon-outline"
                fontIcon="settings"
                matTooltip="Gerenciar"
                (click)="managerItemEvent(element)"
              />

              <mat-icon
                *ngIf="column.key.view"
                class="btn-icon-outline"
                fontIcon="visibility"
                matTooltip="Visualizar"
                (click)="viewItemEvent(element)"
              />

              <mat-icon
                *ngIf="column.key.applyDiscount"
                class="btn-icon-outline"
                fontIcon="sell"
                matTooltip="Aplicar desconto"
                (click)="applyDiscountEvent(element)"
              />

              <mat-icon
                *ngIf="column.key.delete && !spinLoad.remove"
                class="btn-icon-outline"
                fontIcon="delete"
                matTooltip="Excluir"
                (click)="deleteItemEvent(element)"
              />
              <mat-spinner
                *ngIf="column.key.delete && spinLoad.remove"
                diameter="24"
              ></mat-spinner>
            </div>
          } @else if (column.keyColumn == 'phone') {
            {{ element[column.key] | telefone }}
          } @else if (column.keyColumn == 'cpf') {
            {{ element[column.key] | cpf }}
          } @else if (column.keyColumn == 'cnpj') {
            {{ element[column.key] | cnpj }}
          } @else if (column.keyColumn == 'period') {
            {{ element.dataInicio }} - {{ element.dataFim }}
          } @else if (column.keyColumn == 'event_period') {
            <b>Inicio:</b> {{ element.dataEventoInicio }}<br />
            <b>Fim:</b> {{ element.dataEventoFim }}
          } @else if (column.keyColumn == 'tg_info') {
            <b>Tg: </b>{{ element.tg }}<br />
            <b>Evento: </b>{{ element.nomeEvento ?? '-' }}
          } @else if (column.keyColumn == 'client_info') {
            <b>Cliente: </b>{{ element.nome }}<br />
            <b>SubCliente: </b>{{ element.subClienteNome ?? '-' }}
          } @else if (column.keyColumn == 'consultant_info') {
            <b>Cliente: </b>{{ element.consultorNome }}<br />
            <b>Comercial: </b>{{ element.consultorComercialNome ?? '-' }}
          } @else {
            {{ element[column.key] }}
          }
        </td>
      </ng-container>
    }
    <tr
      mat-header-row
      class="style-header"
      *matHeaderRowDef="displayedColumns"
    ></tr>
    <tr
      mat-row
      class="style-row"
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>
} @else {
  <div>
    <h3 class="text-center">Sem registros.</h3>
  </div>
}

<!--    <ng-container *ngFor="let column of columns;" matColumnDef="{{column.keyColumn}}">-->
<!--      <th mat-header-cell *matHeaderCellDef> {{ column.description }} </th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        @if (column.keyColumn == 'action') {-->
<!--          <button mat-flat-button class="btn-tg w-1/5" >-->
<!--            Editar-->
<!--          </button>-->
<!--        } @else {-->
<!--          {{element[column.key]}}-->
<!--        }-->
<!--      </td>-->
<!--    </ng-container>-->
